import React from 'react';
import PropTypes from 'prop-types';
import { Draggable } from 'react-beautiful-dnd';
import fr from 'facet-rest';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';

const useStyles = buildUseStyles('DraggableResourceItem', () => ({
  root: {
    width: '100%',
  },
}));

/**
 * DraggableResourceItem component renders an individual resource item that can be dragged
 * to reorder within the prioritization list. Mobile-friendly with touch support.
 */
export function DraggableResourceItem({
  resourceGroup,
  index,
  Component,
  ComponentProps,
  disabled = false,
}) {
  const classes = useStyles();
  if (!resourceGroup || resourceGroup.length === 0) {
    return null;
  }
  const headResource = resourceGroup[0];

  return (
    <Draggable
      key={headResource.id()}
      draggableId={headResource.id()}
      index={index}
      className={classes.fullWidth}
      isDragDisabled={disabled}
    >
      {(draggableProvided, snapshot) => (
        <div
          ref={draggableProvided.innerRef}
          {...draggableProvided.draggableProps}
          {...draggableProvided.dragHandleProps}
          style={{
            ...draggableProvided.draggableProps.style,
          }}
          className={classes.root}
        >
          <Component
            index={index}
            resourceGroup={resourceGroup}
            disabled={disabled}
            isDragging={snapshot.isDragging}
            {...ComponentProps}
          />
        </div>
      )}
    </Draggable>
  );
}

DraggableResourceItem.propTypes = {
  /** resourceGroup object */
  resourceGroup: PropTypes.arrayOf(PropTypes.instanceOf(fr.Resource)).isRequired,
  /** Index position of the resource in the list */
  index: PropTypes.number.isRequired,
  /** Component component to render the item */
  Component: PropTypes.func.isRequired,
  /** Disabld sorting */
  disabled: PropTypes.bool,
  /** Props to pass to the item component */
  ComponentProps: PropTypes.object,
};
